/**
 * Configuração de marca do cliente.
 *
 * Para publicar uma instância nova: defina VITE_BRAND_NAME (e opcionalmente
 * VITE_BRAND_TAGLINE) no .env do cliente, e troque o arquivo
 * src/assets/logo-client.png pela logo dele — nada mais precisa mudar.
 */
import logoClient from "@/assets/logo-client.png";

export const BRAND_NAME = import.meta.env.VITE_BRAND_NAME || "Sua Marca";
export const BRAND_TAGLINE =
  import.meta.env.VITE_BRAND_TAGLINE || "Sistema de gestão de manutenção de piscinas";
export const BRAND_LOGO = logoClient;
